import React from 'react';

import Button from '@atlaskit/button';

import { useTestCaseExecutionStatusPageContext } from '../TestCaseExecutionStatusPageProvider';
import SchemeTable from './SchemeTable';
import { TableHeaderStyled, TableWrapperStyled } from './StatusScheme.styled';

export default function StatusScheme(): JSX.Element {
  const { changeScreen, isEditScreen } =
    useTestCaseExecutionStatusPageContext();

  return (
    <TableWrapperStyled isEditMode={isEditScreen}>
      {!isEditScreen && (
        <TableHeaderStyled>
          <h4>Test Case Execution Status Scheme</h4>
          <Button appearance='subtle' onClick={changeScreen}>
            Edit Scheme
          </Button>
        </TableHeaderStyled>
      )}
      <SchemeTable />
    </TableWrapperStyled>
  );
}
